import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    getSailthruNewslettersByTokenType,
    getSailthruNewslettersType,
} from "./__graphql-types__/index.ts";

export const SAILTHRU_NEWSLETTERS_QUERY_BY_TOKEN: GqlOperation<
    getSailthruNewslettersByTokenType["response"],
    getSailthruNewslettersByTokenType["variables"]
> = gqlOp(gql`
    query getSailthruNewslettersByToken($token: String!) {
        emailSettingsFromUnsubscribeToken(token: $token) {
            emailSubscriptions {
                sailthruSubscriptions {
                    checked
                    description
                    key
                }
            }
        }
    }
`);

export const SAILTHRU_NEWSLETTERS_QUERY_BY_KAID: GqlOperation<
    getSailthruNewslettersType["response"],
    getSailthruNewslettersType["variables"]
> = gqlOp(gql`
    query getSailthruNewsletters($targetKaid: String) {
        target: user(kaid: $targetKaid) {
            id
            emailSubscriptions {
                sailthruSubscriptions {
                    checked
                    description
                    key
                }
            }
        }
    }
`);
